// import type { UINotification } from 'types/notification'

type UINotification = any

export const STORAGE_DISABLED_NOTIFICATION: UINotification = {
  // prettier-ignore
  message: `Third-party storage looks to be disabled in your browser. DISCO needs third-party storage enabled to work properly. Please find instructions for enabling it |${JSON.stringify({ externalLink: { label: 'here.', url: 'https://support.disco.ac/home/enabling-third-party-storage-in-your-web-browser' } })}|`,
  level: 'error',
}

export const STORAGE_FULL_NOTIFICATION: UINotification = {
  // prettier-ignore
  message: `Local Storage in your browser is full or unavailable. Please find instructions to clear Local Storage for your browser |${JSON.stringify({ externalLink: { label: 'here.', url: 'https://support.disco.ac/home/clearing-local-storage-in-your-web-browser' } })}|`,
  level: 'error',
}
